// Feature flag for New Web pricing
export const getWebPricingFeatureFlag = () => window.flags && window.flags['GNA-11926-NEW-WEB-PRICING'];

// Feature flag for Hiding Logged out Pricing
export const hideLoggedOutPricingFF = () => window.flags && window.flags["GNA-12455-HIDE-LOGGEDOUT-PRICING-BY-SALESORG"];